/**
 * @generated SignedSource<<c45d5493b548869a192ce85dd5efe3c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTasks_tasks$data = {
  readonly tasks: {
    readonly countGroupedByStatus: ReadonlyArray<{
      readonly color: string;
      readonly count: number;
      readonly identifier: string;
      readonly name: string;
    }> | null;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly descriptionText: string | null;
        readonly dueDate: string | null;
        readonly id: string;
        readonly tenant: {
          readonly name: string;
        } | null;
        readonly titleText: string;
        readonly url: string;
        readonly " $fragmentSpreads": FragmentRefs<"AssigneesPreview__node" | "Status__status">;
      };
    } | null>;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    };
    readonly total: number | null;
  } | null;
  readonly " $fragmentType": "useTasks_tasks";
};
export type useTasks_tasks$key = {
  readonly " $data"?: useTasks_tasks$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTasks_tasks">;
};
const node: ReaderFragment = function () {
  var v0 = {
      "kind": "Variable",
      "name": "filter",
      "variableName": "filter"
    },
    v1 = {
      "kind": "Variable",
      "name": "tenantIds",
      "variableName": "tenantIds"
    },
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    };
  return {
    "argumentDefinitions": [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "limit"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "page"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sort"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantIds"
    }],
    "kind": "Fragment",
    "metadata": {
      "connection": [{
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": ["tasks"]
      }]
    },
    "name": "useTasks_tasks",
    "selections": [{
      "alias": "tasks",
      "args": [v0 /*: any*/, {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      }, {
        "kind": "Variable",
        "name": "page",
        "variableName": "page"
      }, {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort"
      }, v1 /*: any*/],

      "concreteType": "TaskConnectionType",
      "kind": "LinkedField",
      "name": "__useTasks_tasks_connection",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      }, {
        "alias": null,
        "args": [v0 /*: any*/, v1 /*: any*/],

        "concreteType": "CountGroupedByStatus",
        "kind": "LinkedField",
        "name": "countGroupedByStatus",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identifier",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }, v2 /*: any*/, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "concreteType": "TaskConnectionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "_Task",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionText",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "titleText",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "concreteType": "_Tenant",
            "kind": "LinkedField",
            "name": "tenant",
            "plural": false,
            "selections": [v2 /*: any*/],

            "storageKey": null
          }, {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AssigneesPreview__node"
          }, {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Status__status"
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "_Viewer",
    "abstractKey": null
  };
}();
(node as any).hash = "c2a77e6c09b890dd030686de7eed033d";
export default node;